import Heading from '@/components/atoms/Heading';
import { theme } from '@/styles/theme';
import styled, { css } from 'styled-components';

const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing[6]}px;
`;

const ArrowTypeContainer = styled.div`
  ${({ theme }) => {
    return css`
      background-color: ${theme.colors.accent.accent[9]};
      border-radius: ${theme.radius[2]}px;
      padding: ${theme.spacing[2]}px;
    `;
  }}
`;

const ArrowLine = styled.div`
  width: 100%;
  border-bottom: 2px solid ${({ theme }) => theme.colors.accent.accent[9]};
`;

interface IndicadorTipoPublicacaoProps {
  $tipoPublicacao: 'Notícias' | 'Críticas';
}

export default function IndicadorTipoPublicacao(
  props: IndicadorTipoPublicacaoProps,
) {
  const { $tipoPublicacao } = props;
  return (
    <ArrowContainer>
      <ArrowTypeContainer>
        <Heading
          $priority={5}
          $size={1}
          $color={theme.tokens.colors.black_contrast}
          $align="left"
          $highContrast={false}
          $weight="bold"
          $fontFamily="news"
          $text={$tipoPublicacao}
          $quebraTexto={false}
          style={{
            textTransform: 'uppercase',
          }}
        />
      </ArrowTypeContainer>
      <ArrowLine />
    </ArrowContainer>
  );
}
